import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React from 'react';
import {
  useStyles,
} from './constants';

const HumidityTemperatureAlertLimit: React.FC<any> = ({
  limits,
  measurements,
  isFieldEditable,
  isViewMode,
  setLimits,
}) => {
  const classes = useStyles();

  const handleLimitChange = (index: number, field: string, value: string | number | boolean) => {
    if (isViewMode) return;

    // Validate numeric value for 'value' field
    if (field === 'value') {
      const numericRegex = /^\d+(\.\d+)?$/;
      if (!numericRegex.test(value.toString())) {
        return;
      }
    }

    const newLimits = [...limits];
    newLimits[index] = { ...newLimits[index], [field]: value };
    setLimits(newLimits);
  };

  const removeLimit = (index: number) => {
    if (isViewMode) return;
    const newLimits = limits.filter((_: any, i: number) => i !== index);
    setLimits(newLimits);
  };

  return (
    limits.map((limit: any, index: number) => (
      <Box key={index} className={classes.limitContainer}>
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <Select
            value={limit.name || ''}
            onChange={(e) => handleLimitChange(index, 'name', e.target.value)}
            label="Medición"
            disabled={!isFieldEditable('name')}
            displayEmpty
            renderValue={(selected) => {
              if (!selected) {
                return <em>Seleccione una medición</em>;
              }
              const found = measurements.find((m: any) => m.id === selected);
              return found ? found.name : selected;
            }}
          >
            <MenuItem value="">
              <em>Seleccione una medición</em>
            </MenuItem>
            {measurements.map((measurement: any) => (
              <MenuItem key={measurement.id} value={measurement.id}>
                {measurement.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          label="Valor"
          value={limit.value}
          onChange={(e) => handleLimitChange(index, 'value', Number(e.target.value))}
          size="small"
          disabled={!isFieldEditable('value')}
        />
        <FormControl size="small">
          <InputLabel>Posición</InputLabel>
          <Select
            value={limit.top.toString()}
            onChange={(e) => handleLimitChange(index, 'top', e.target.value === 'true')}
            label="Posición"
            disabled={!isFieldEditable('top')}
          >
            <MenuItem value="true">Superior</MenuItem>
            <MenuItem value="false">Inferior</MenuItem>
          </Select>
        </FormControl>
        {!isViewMode && (
          <IconButton onClick={() => removeLimit(index)} size="small">
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
    ))
  );
};

export default HumidityTemperatureAlertLimit;
